import {ButtonBase} from './ButtonBase';
import {withComponent} from '../../hoc/withComponent';

export const withButton = withComponent(ButtonBase);
